import { consolidatedPicking } from "../picking-consolidated.config";
import { DataTable } from "../../../data-table.interface";

const iconsOfActionsList = [
  {
    icon: 'new-lot',
    tooltip: 'Crear lote',
    hasVisibleCondition: (element: any[]) => {
      return true;
    }
  },
];

export const dispatchesToCreateLots:DataTable = {
  searchText: '',
  addText: '',
  checkbox: true,
  expandable: true,
  export: false,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  iconsOfActions: iconsOfActionsList,
  paginator: true,
  columns: consolidatedPicking.columns
};
